import { c as _c } from "react/compiler-runtime";
import { useApplicationTranslation } from "@lib/hooks/translations";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import { ApplicationFormValues } from "@lib/mapApplicationData/types";
import { FormStepComponent } from "../FormSteps/FormSteps";
import ApplicationLeadWallComponent from "./ApplicationLeadWallComponent";
import { certificateSlide, consultationSlide, interestRateAlarmSlide, personalResultsSlide } from "./slides";
import { getTexts } from "./texts";
interface ApplicationLeadWallProps extends FormStepComponent<ApplicationFormValues> {}
const ApplicationLeadWall = props => {
  const $ = _c(9);
  const {
    t
  } = useApplicationTranslation();
  const {
    partner
  } = usePartnerContext();
  const t0 = !!partner;
  let t1;
  if ($[0] !== t || $[1] !== t0) {
    t1 = getTexts(t, false, t0);
    $[0] = t;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    title,
    description,
    listItems
  } = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [certificateSlide, personalResultsSlide, interestRateAlarmSlide, consultationSlide];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description || $[5] !== listItems || $[6] !== props || $[7] !== title) {
    t3 = <ApplicationLeadWallComponent slides={t2} leadCreationAction="CONTACT_WALL" title={title} description={description} listItems={listItems} {...props} />;
    $[4] = description;
    $[5] = listItems;
    $[6] = props;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default ApplicationLeadWall;